import React from 'react';

import Heading from '@atlaskit/heading';

import {
  DoneIcon,
  ErrorIcon,
  LoadingIcon,
  WaitIcon
} from 'src/views/components/commonIcons';


const WebhooksTableSummary = ({ statuses, isRunning }) => {
  const total = statuses.length;
  const success = statuses.filter(p => p.status === 'done').length;
  const error = statuses.filter(p => p.status === 'error').length;

  return (
    <div style={{ paddingTop: '20px' }}>
      <Heading size="small">Webhooks update summary</Heading>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ width: 24, height: 24, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {(total - success - error > 0) && isRunning && <LoadingIcon/>}
          {(total - success - error > 0) && !isRunning && <WaitIcon/>}
        </div>
        <div>Total: {success + error}/{total} ({total - success - error} left)</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ width: 24, height: 24 }}><DoneIcon/></div>
        <div>Success: {success}/{total}</div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ width: 24, height: 24 }}><ErrorIcon/></div>
        <div>Error: {error}/{total}</div>
      </div>
    </div>
  );
};

export default WebhooksTableSummary;
